import QueryParamsUtil from 'api/utils/query-params-util'
import axios from 'axios'

const API_PATH = 'api/v2/admins/cms/featured_sellers'

const CmsFeaturesSellersApiV2 = {

  /**
   * Create a Cms for Featured Seller
   * Invoke `POST api/v2/admins/cms/featured_sellers'
   * @param {object} payload - Payload data to be send to backend
   */
  create: async (payload) => {
    const path = API_PATH

    const response = axios.post(path, payload)

    return response
  },
  /**
   * Update a Cms for Featured Seller
   * Invoke `PATCH api/v2/admins/cms/featured_sellers/:url'
   * @param {string} url CMS Featured Seller Url
   * @param {object} payload - Payload data to be send to backend
   */
  update: async (url, payload) => {
    const path = `${API_PATH}/${url}`

    const response = axios.patch(path, payload)

    return response
  },
  /**
   * Show CMS Feaured Seller by specific id
   * Invoke `GET api/v2/admins//cms/featured_sellers/:url`
   * @param {string} url CMS Featured Seller Url
   */
  getSingle: async (url) => {
    const path     = `${API_PATH}/${url}`
    const response = axios.get(path)

    return response
  },
  /**
   * Get list of Cms Featured Sellers
   * Invoke `GET api/v2/admins/cms/featured_sellers'
   * @param {object} tableState - ReactTable final state
   * @param {object} additionalFilters - A plain object to get customize filters outside `tableState`
   */
  get: async (tableState, additionalFilters) => {
    const params = QueryParamsUtil.format(tableState, additionalFilters)
    const path   = API_PATH

    const response = axios.get(path, { params })
    return response
  },

  /**
   * Filter list of Cms Featured Sellers based on specific seller name
   * Invoke `GET api/v2/admins/cms/featured_sellers'
   * @param {string} sellerName - typed seller name
   */
  filterByName: async (sellerName) => {
    const params = { seller_name: sellerName }
    const path   = API_PATH

    const response = axios.get(path, { params })
    return response
  }

}

export default CmsFeaturesSellersApiV2
